import React, { useEffect } from "react";
import Checkboxes from "./QuestionsBody/CheckBoxes/Checkboxes";
import Scores from "./QuestionsBody/Scores/Scores";
import ShortAnswer from "./QuestionsBody/ShortAnswer/ShortAnswer";
import SingleChocie from "./QuestionsBody/SingleChocie/SingleChocie";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { BiError } from "react-icons/bi";
import Loader from "../../Loader/Loader";
import Translate from "../../../i18n/i18nTranslate";
import BooleanAnswer from "./QuestionsBody/Boolean/booleanAnswer";

export default function PreviewQuestions({
  index,
  options,
  title,
  description,
  emoji,
  firstEmojiUrl,
  secondEmojiUrl,
  tpye,
  required,
  answers,
  bgrequired,
  onChangeSingle,
  onFocusInput,
  QuestionFontScales,
  QuestionDescriptionFontScales,
  AnswersFontScales,
  InputAnswersFontScales,
  totalIndex
}) {
  function QuestionsType(type) {
    switch (type) {
      case "multi":
        return (
          <Checkboxes
            options={options}
            questionsindex={index}
            answers={answers}
            AnswersFontScales={AnswersFontScales}
          />
        );
      case "single":
        return (
          <SingleChocie
            onChangeSingle={onChangeSingle}
            options={options}
            questionsindex={index}
            answers={answers}
            AnswersFontScales={AnswersFontScales}
          />
        );
      case "boolean":
        return (
          <BooleanAnswer
            options={options}
            questionsindex={index}
            isEmoji={emoji}
            firstEmojiUrl={firstEmojiUrl}
            secondEmojiUrl={secondEmojiUrl}
            answers={answers}
            onChangeSingle={onChangeSingle}
          />
        );
      case "score":
        return <Scores
          questionsindex={index}
          answers={answers}
          AnswersFontScales={AnswersFontScales}
        />;
      case "input":
        return (
          <ShortAnswer
            questionsindex={index}
            answers={answers}
            onChangeSingle={onChangeSingle}
            onFocusInput={onFocusInput}
            InputAnswersFontScales={InputAnswersFontScales}
          />
        );
      default:
        break;
    }
  }

  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  const exampleVariant = {
    visible: {
      opacity: 1,
      scale: 1,

      transition: { duration: 0.8 },
    },
    hidden: { opacity: 0, scale: 1 },
  };

  if (bgrequired === undefined) {
    return <Loader />;
  }
  return (
    <div className="md:m-10 mt-10">
      <motion.div
        animate={control}
        ref={ref}
        className="box"
        variants={exampleVariant}
      >
        <div
          className={
            bgrequired
              ? "flex flex-col w-full px-5 h-full p-3 bg-white justify-center md:px-20 items-center"
              : "flex flex-col w-full px-5 h-full border-dashed     p-3 bg-white  md:border-4 border-red-200 rounded-xl justify-center md:px-20 items-center"
          }
        >
          <div className="flex flex-col items-start w-full">
            {totalIndex > 1 && (
              <div className="divider text-black/60 font-bold" style={{ fontSize: 20 }}>
                {Translate("Soru", "Components.Preview.PreviewQuestions.Question")} {index + 1}
              </div>
            )}

            <div className="flex flex-wrap justify-start items-start w-full px-2">
              <div
                className={`mt-4 ${QuestionFontScales} text-black font-bold break-words w-auto max-w-full text-left`}
              >
                {title}
              </div>
              <div className={`mt-4 ${QuestionFontScales} text-red-500 ml-2`}>
                {required ? "*" : ""}
              </div>
            </div>

            {/* Description */}
            <div
              className={`${QuestionDescriptionFontScales} mt-1 text-black/60 break-words w-full px-2`}
            >
              {description}
            </div>

          </div>
          <div className="flex flex-col w-full mt-2">{QuestionsType(tpye)}</div>
          {!bgrequired && (
            <div className="flex items-center justify-center">
              <BiError className="text-red-500 md:text-[32px] text-md"></BiError>
              <div className="md:text-2xl text-md ml-2 text-red-500">
                {Translate("Soru", "Components.Preview.PreviewQuestions.Must_Filled")}
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
